import { Location } from "../models/location";

export class LocationsToDelimitedStringValueConverter {
	toView(array: Array<Location>) {
		if (array === undefined) {
			return "";
		}
			return array.sort((a, b) => a.name.localeCompare(b.name))
				.map(o => o.name)
				.join(", ");

	}
}